// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 869) return "static/css/869.33bb3ca98b300c7c95b5.lib.css";
	if (chunkId === 835) return "static/css/835.2bc78c1d34eb319e014d.css";
	// return url for filenames based on template
	return undefined;
};